export default function PolitiqueConfidentialite() {
  return (
    <div className="container mb-5 px-3 px-md-4" style={{ maxWidth: '800px' }}>
      <h1 className="mb-2 text-center" style={{ fontSize: 'clamp(1.3rem, 5vw, 2rem)', fontWeight: 700 }}>
        Politique de Confidentialité
      </h1>
      <p className="text-center text-muted mb-4" style={{ fontSize: '0.85rem' }}>
        Dernière mise à jour : juin 2025
      </p>

      {/* ── 1. Responsable du traitement ─────────────────────────────────── */}
      <section className="mb-4">
        <h2 style={{ fontSize: '1.1rem', fontWeight: 700 }}>1. Responsable du traitement</h2>
        <p>
          Le responsable du traitement des données personnelles collectées via l'application
          SpotyPark est :<br />
          <strong>SpotyPark</strong> — 14 rue de la source perdue, 95290 L'Isle-Adam — Application gratuite<br />
          <a href="/contact">Nous contacter</a>
        </p>
      </section>

      {/* ── 2. Données collectées ─────────────────────────────────────────── */}
      <section className="mb-4">
        <h2 style={{ fontSize: '1.1rem', fontWeight: 700 }}>2. Données collectées</h2>
        <p>Nous collectons les données suivantes :</p>
        <ul>
          <li><strong>Identité :</strong> prénom, nom, adresse e-mail, numéro de téléphone, date de naissance, pseudo.</li>
          <li><strong>Véhicule :</strong> type, marque et immatriculation du véhicule.</li>
          <li><strong>Localisation :</strong> lors du signalement ou de la réservation d'une place, et uniquement si vous activez la géolocalisation.</li>
          <li><strong>Données de transaction :</strong> montants, dates, identifiants de réservation. Les données bancaires sont traitées exclusivement par Stripe (jamais stockées par SpotyPark).</li>
          <li><strong>Données d'usage :</strong> journaux de connexion, actions effectuées, signalements, notations.</li>
          <li><strong>Photo de profil :</strong> si vous choisissez d'en télécharger une.</li>
        </ul>
      </section>

      {/* ── 3. Base légale et finalités ──────────────────────────────────── */}
      <section className="mb-4">
        <h2 style={{ fontSize: '1.1rem', fontWeight: 700 }}>3. Base légale et finalités du traitement</h2>
        <table className="table table-bordered table-sm" style={{ fontSize: '0.88rem' }}>
          <thead className="table-light">
            <tr>
              <th>Finalité</th>
              <th>Base légale</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>Création et gestion de votre compte</td>
              <td>Exécution du contrat</td>
            </tr>
            <tr>
              <td>Réservations et transactions entre utilisateurs</td>
              <td>Exécution du contrat</td>
            </tr>
            <tr>
              <td>Signalement de places disponibles</td>
              <td>Exécution du contrat</td>
            </tr>
            <tr>
              <td>Géolocalisation pendant la navigation GPS</td>
              <td>Consentement explicite</td>
            </tr>
            <tr>
              <td>Notifications liées à l'application</td>
              <td>Intérêt légitime</td>
            </tr>
            <tr>
              <td>Prévention de la fraude et sécurité</td>
              <td>Intérêt légitime</td>
            </tr>
            <tr>
              <td>Conservation des données comptables</td>
              <td>Obligation légale (10 ans)</td>
            </tr>
            <tr>
              <td>Amélioration du service (statistiques anonymes)</td>
              <td>Intérêt légitime</td>
            </tr>
          </tbody>
        </table>
      </section>

      {/* ── 4. Durées de conservation ─────────────────────────────────────── */}
      <section className="mb-4">
        <h2 style={{ fontSize: '1.1rem', fontWeight: 700 }}>4. Durées de conservation</h2>
        <ul>
          <li><strong>Données de compte :</strong> conservées pendant toute la durée d'activité du compte, puis supprimées dans un délai de 30 jours après clôture.</li>
          <li><strong>Données de transaction :</strong> 10 ans à compter de la transaction (obligation comptable et fiscale).</li>
          <li><strong>Données de géolocalisation :</strong> supprimées immédiatement après la confirmation de transaction.</li>
          <li><strong>Journaux de connexion :</strong> 12 mois (obligation légale).</li>
          <li><strong>Données de litiges :</strong> 5 ans à compter de la clôture du litige.</li>
        </ul>
      </section>

      {/* ── 5. Partage des données ────────────────────────────────────────── */}
      <section className="mb-4">
        <h2 style={{ fontSize: '1.1rem', fontWeight: 700 }}>5. Partage des données</h2>
        <p>Vos données personnelles ne sont <strong>jamais vendues</strong>. Elles peuvent être partagées uniquement avec :</p>
        <ul>
          <li><strong>Les autres utilisateurs :</strong> uniquement les informations nécessaires à une réservation (prénom, localisation approximative de la place).</li>
          <li><strong>Firebase / Google Cloud :</strong> hébergement et base de données, serveurs situés en Europe (Belgique). Des transferts hors UE peuvent intervenir dans le cadre des services Google, encadrés par les clauses contractuelles types de la Commission européenne.</li>
          <li><strong>Stripe :</strong> traitement des paiements, soumis à sa propre politique de confidentialité.</li>
          <li><strong>HERE Technologies :</strong> cartographie et géocodage des adresses.</li>
          <li><strong>Les autorités compétentes :</strong> si la loi l'exige.</li>
        </ul>
      </section>

      {/* ── 6. Sécurité ──────────────────────────────────────────────────── */}
      <section className="mb-4">
        <h2 style={{ fontSize: '1.1rem', fontWeight: 700 }}>6. Sécurité</h2>
        <p>
          SpotyPark met en œuvre des mesures techniques et organisationnelles adaptées :
          chiffrement des communications (HTTPS), accès restreint aux données, authentification
          sécurisée via Firebase Auth, infrastructure certifiée ISO 27001.
          Aucun système n'est totalement inviolable ; en cas de violation de données, vous
          serez notifié conformément à la réglementation en vigueur.
        </p>
      </section>

      {/* ── 7. Décisions automatisées ────────────────────────────────────── */}
      <section className="mb-4">
        <h2 style={{ fontSize: '1.1rem', fontWeight: 700 }}>7. Décisions automatisées</h2>
        <p>
          SpotyPark peut appliquer des suspensions automatiques de compte en cas de
          non-respect répété de la charte (ex : annulations abusives). Ces décisions
          sont basées sur des règles prédéfinies et peuvent faire l'objet d'une contestation
          en contactant notre support.
        </p>
      </section>

      {/* ── 8. Vos droits ────────────────────────────────────────────────── */}
      <section className="mb-4">
        <h2 style={{ fontSize: '1.1rem', fontWeight: 700 }}>8. Vos droits</h2>
        <p>Conformément au RGPD, vous disposez des droits suivants :</p>
        <ul>
          <li><strong>Droit d'accès :</strong> obtenir une copie de vos données personnelles.</li>
          <li><strong>Droit de rectification :</strong> corriger des données inexactes.</li>
          <li><strong>Droit à l'effacement :</strong> supprimer votre compte et vos données (sous réserve des obligations légales de conservation).</li>
          <li><strong>Droit d'opposition :</strong> vous opposer à certains traitements basés sur l'intérêt légitime.</li>
          <li><strong>Droit à la portabilité :</strong> recevoir vos données dans un format structuré.</li>
          <li><strong>Droit de retirer votre consentement</strong> à tout moment pour les traitements basés sur celui-ci (ex : géolocalisation).</li>
        </ul>
        <p>
          Pour exercer ces droits : <a href="/contact">Cliquer sur le lien</a><br />
          Vous pouvez également introduire une réclamation auprès de la <strong>CNIL</strong> :{' '}
          <a href="https://www.cnil.fr" target="_blank" rel="noopener noreferrer">www.cnil.fr</a>
        </p>
      </section>

      {/* ── 9. Cookies ───────────────────────────────────────────────────── */}
      <section className="mb-4">
        <h2 style={{ fontSize: '1.1rem', fontWeight: 700 }}>9. Cookies et technologies similaires</h2>
        <p>
          L'application utilise des cookies techniques indispensables au fonctionnement
          (authentification, session). Aucun cookie publicitaire ou de tracking tiers
          n'est utilisé sans votre consentement.
        </p>
      </section>

      {/* ── 10. Modifications ────────────────────────────────────────────── */}
      <section className="mb-4">
        <h2 style={{ fontSize: '1.1rem', fontWeight: 700 }}>10. Modifications</h2>
        <p>
          Toute modification substantielle de cette politique vous sera notifiée via
          l'application ou par e-mail au moins 30 jours avant son entrée en vigueur.
        </p>
      </section>

      {/* ── 11. Contact ──────────────────────────────────────────────────── */}
      <section>
        <h2 style={{ fontSize: '1.1rem', fontWeight: 700 }}>11. Contact</h2>
        <p>
          SpotyPark — <a href="/contact">Nous contacter</a><br />
          <a href="https://www.spotypark.fr" target="_blank" rel="noopener noreferrer">
            www.spotypark.fr
          </a>
        </p>
      </section>
    </div>
  );
}